/**
 * Holding — мастер-таблица объединения компаний (entities) под одним юридическим зонтиком.
 * Multi-tenancy: holding_admin даёт автоматический доступ ко всем entities в holdings.
 * S-multi-1 BM-1-1.
 */
import { z } from 'zod';
import { IsoDateTime, UuidString } from '../primitives.js';

export const HoldingStatus = z.enum(['active', 'archived']);
export type HoldingStatus = z.infer<typeof HoldingStatus>;

export const Holding = z.object({
  id: UuidString,
  name: z.string().min(1).max(200),
  status: HoldingStatus,
  created_at: IsoDateTime,
  updated_at: IsoDateTime,
});
export type Holding = z.infer<typeof Holding>;

export const HoldingCreate = z
  .object({
    name: z.string().min(1).max(200),
    status: HoldingStatus.optional().default('active'),
  })
  // zod-strict-ok: input request-body
  .strict();
export type HoldingCreate = z.infer<typeof HoldingCreate>;

export const HoldingPatch = z
  .object({
    name: z.string().min(1).max(200).optional(),
    status: HoldingStatus.optional(),
  })
  // zod-strict-ok: input request-body
  .strict();
export type HoldingPatch = z.infer<typeof HoldingPatch>;

/** List response с denorm `total_entities_count` per holding. */
export const HoldingListItem = Holding.extend({
  total_entities_count: z.number().int().min(0),
});
export type HoldingListItem = z.infer<typeof HoldingListItem>;

export const HoldingList = z.object({
  items: z.array(HoldingListItem),
  next_cursor: z.string().nullable().optional(),
});
export type HoldingList = z.infer<typeof HoldingList>;
